import React, { useState, useEffect } from "react";

import "./netswitch.css";
import "../../../theme.css";
import { useIBC } from "../../../hooks/useIBC";
import { useLiquidity } from "../../../hooks/useLiquidity";
import { PulseLoader } from "react-spinners";
import { useRecoilValue } from "recoil";
import { walletState } from "../../../context/walletState";

const RewardClaim = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [pendingReward, setPendingReward] = useState(0);
  const ibc = useIBC();
  const liquidity = useLiquidity();
  const [isLoading, setisLoading] = useState(false);
  const {client, address} = useRecoilValue(walletState)

  useEffect(() => {
    const fetchPendingReward = async () => {
      setisLoading(true);
      const rewardsPending = await ibc.getPendingRewards();
      setPendingReward(Number(rewardsPending) ? Number(rewardsPending) : 0.0);
      setisLoading(false);
    };
    fetchPendingReward();
  }, [client]);

  const handleReward = async () => {
    const totalBonded = await liquidity.getPoolTotalBonded("sJUNO-sSCRT");
    // console.log("totalBonded: ", totalBonded);
    const claimResponse = await ibc.doClaimRewards();
  };

  return (
    <div className="reward-wrapper">
      <div className="reward-and-button">
        <p>
          {/* {pendingReward.toFixed(4)} <span> SGOV</span> */}
        </p>
        <div className="reward-container" onClick={handleReward}>
          <div>Claim</div> <span className="tempo">{
            isLoading?
            <PulseLoader
          color="#1790FF"
          loading={true}
          // cssOverride={override}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        :
          pendingReward.toFixed(2)
          } </span>
        </div>
      </div>
      {isOpen ? (
        <div className="reward-container-open">
          <div className="rewards-div">Unclaimed Balance</div>
          <button className="common-button rewards-claim-button">
            Claim All Rewards
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default RewardClaim;
